import React from 'react';
import {
  SUBSCRIPTION_TRIAL,
  SUBSCRIPTION_ENTERPRISE,
  isCreatorSubscription,
  isBusinessSubscription,
  SUBSCRIPTION_CREATOR,
  SUBSCRIPTION_BUSINESS,
} from '../../config';

interface Props {
  selectedPlan: number;
  setSelectedPlan: (plan: number) => void;
}

const PlansSwitch = React.memo(({selectedPlan, setSelectedPlan}: Props) => {
  return (
    <div className="PlansSwitchContainer">
      <button
        className={selectedPlan === SUBSCRIPTION_TRIAL ? 'Selected' : ''}
        onClick={() => setSelectedPlan(SUBSCRIPTION_TRIAL)}>
        Trial
      </button>
      <button
        className={isCreatorSubscription(selectedPlan) ? 'Selected' : ''}
        onClick={() => setSelectedPlan(SUBSCRIPTION_CREATOR)}>
        Creator
      </button>
      <button
        className={isBusinessSubscription(selectedPlan) ? 'Selected' : ''}
        onClick={() => setSelectedPlan(SUBSCRIPTION_BUSINESS)}>
        Business
      </button>
      <button
        className={`LastElement ${
          selectedPlan === SUBSCRIPTION_ENTERPRISE ? 'Selected' : ''
        }`}
        onClick={() => setSelectedPlan(SUBSCRIPTION_ENTERPRISE)}>
        Enterprise
      </button>
    </div>
  );
});

export default PlansSwitch;
